module.exports = __webpack_public_path__ + "static/media/why_hr.c1f6e2ed.vtt";